import React, { useState, useRef, useEffect } from 'react';
import './SelectForm.css';

const SelectForm = ({
  label,
  name,
  value,
  onChange,
  required = false,
  placeholder = '',
  options = [],
  className = '',
  error
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      // Prevenir scroll mientras el dropdown está abierto
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleSelect = (optionValue, e) => {
    e.stopPropagation();
    onChange({ target: { name, value: optionValue } });
    setIsOpen(false);
  };

  const getCurrentLabel = () => {
    if (!value) return '';
    
    for (const group of options) {
      if (group.options) {
        const option = group.options.find(opt => opt.value === value);
        if (option) return option.text || option.label;
      } else if (group.value === value) {
        return group.text || group.label;
      }
    }
    return '';
  };

  return (
    <div className={`select-form ${isOpen ? 'is-open' : ''} ${className} ${error ? 'has-error' : ''}`} ref={selectRef}>
      <label className="select-form-label" id={`${name}-label`}>
        {label}
        {required && <span className="required">*</span>}
      </label>
      <div className="select-wrapper">
        <div
          className={`select-form-input ${isOpen ? 'open' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
          tabIndex="0"
          role="combobox"
          aria-expanded={isOpen}
          aria-labelledby={`${name}-label`}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setIsOpen(!isOpen);
            }
          }}
        >
          <span className={`select-value ${!value ? 'placeholder' : ''}`}>
            {value ? getCurrentLabel() : placeholder}
          </span>
          <span className="arrow-icon">▼</span>
        </div>

        {isOpen && (
          <>
            <div 
              className="select-overlay" 
              onClick={(e) => {
                e.stopPropagation();
                setIsOpen(false);
              }}
            />
            <div className="select-dropdown">
              {options.map(group => (
                group.options ? (
                  <div key={group.group} className="select-group">
                    <div className="select-group-label">{group.group}</div>
                    {group.options.map(option => (
                      <div
                        key={option.value}
                        className={`select-option ${value === option.value ? 'selected' : ''}`}
                        onClick={(e) => handleSelect(option.value, e)}
                      >
                        {option.text || option.label}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    key={group.value}
                    className={`select-option ${value === group.value ? 'selected' : ''}`}
                    onClick={(e) => handleSelect(group.value, e)}
                  >
                    {group.text || group.label}
                  </div>
                )
              ))}
            </div>
          </>
        )}
      </div>
      <div className="field-feedback">
        {error ? <span className="field-error">{error}</span> : <span className="field-error" style={{ visibility: 'hidden' }}>&nbsp;</span>}
      </div>
    </div>
  );
};

export default SelectForm; 